/* POLARDIP theme JS — header, mobile nav, countdown, gallery, cart count, reveal */
(function () {
  'use strict';

  /* Sticky header: solidify after hero */
  var header = document.querySelector('.pd-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile nav */
  var burger = document.querySelector('[data-burger]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* Countdown timer (pricing-offer section) */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var dEl = el.querySelector('[data-cd-days]');
    var hEl = el.querySelector('[data-cd-hours]');
    var mEl = el.querySelector('[data-cd-mins]');
    var sEl = el.querySelector('[data-cd-secs]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var diff = end - Date.now();
      if (diff <= 0) { el.style.display = 'none'; return; }
      if (dEl) dEl.textContent = pad(Math.floor(diff / 86400000));
      if (hEl) hEl.textContent = pad(Math.floor(diff / 3600000) % 24);
      if (mEl) mEl.textContent = pad(Math.floor(diff / 60000) % 60);
      if (sEl) sEl.textContent = pad(Math.floor(diff / 1000) % 60);
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* Product gallery thumbnails */
  var mainImg = document.querySelector('[data-main-image]');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* Live cart count via AJAX after add-to-cart forms submit normally is handled server side;
     refresh badge from /cart.js on load for accuracy */
  var badge = document.querySelector('[data-cart-count]');
  if (badge) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      })
      .catch(function () {});
  }

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.pd-reveal').forEach(function (el) { io.observe(el); });
  }
})();
